var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.699,
    height: 23.945,
    viewBox: "0 0 24.699 23.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6513",
    x: 0,
    y: 0,
    width: 24.699,
    height: 23.945,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.231
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_6513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6513-2",
    "data-name": "Path 6513",
    d: "M3850.343,2920.266a1.011,1.011,0,0,1-.333.741c-1.013.986-2.021,1.978-3.04,2.957a.825.825,0,0,0-.272.816c.248,1.378.477,2.759.713,4.139a1,1,0,0,1-1.1,1.254,1.37,1.37,0,0,1-.428-.148q-1.888-.986-3.77-1.983a.727.727,0,0,0-.736,0c-1.249.663-2.5,1.317-3.75,1.979a1.1,1.1,0,0,1-.881.118.984.984,0,0,1-.678-1.122q.365-2.16.741-4.316a.694.694,0,0,0-.216-.665c-1.029-1-2.051-2-3.081-3a1.011,1.011,0,0,1,.59-1.782c1.413-.2,2.823-.411,4.235-.612a.714.714,0,0,0,.58-.425c.628-1.281,1.265-2.558,1.891-3.839a1.013,1.013,0,0,1,1.879,0c.625,1.275,1.257,2.547,1.879,3.823a.741.741,0,0,0,.608.446q2.138.3,4.274.62A.989.989,0,0,1,3850.343,2920.266Z",
    transform: "translate(-3829.39 -2909.99)",
    fill: "#fff",
    stroke: "#7E97B8",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/Favorite.645cb69a5e7b358587b9b8390c252d91.svg";
export { ForwardRef as ReactComponent };